exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button i[data-v-0c2f6ec6] {\n  color: #e0e0e0;\n  font-size: 28px;\n  line-height: 24px;\n}\nbutton:hover i[data-v-0c2f6ec6], button:focus i[data-v-0c2f6ec6] {\n  color: #4f4f4f;\n}\n", ""]);

// exports
